import { estadosEvaluacionesApi } from "../view/estados-evaluaciones.service";
import { evaluacionesApi } from "../../distribuciones/distribucionDeEvaluaciones.service";
import { asignaturasPorProfesorApi } from "../../distribuciones/distribucionDeAsignaturasPorProfesor.service";

export const editEstadoEval = estadosEvaluacionesApi.injectEndpoints({
  endpoints: (builder) => ({
    editEstadoEval: builder.mutation({
      query: ({ id, ...rest }) => {
        return {
          url: `/v1/api/estadodeevaluacion/${id}/`,
          method: "PATCH",
          body: rest,
        };
      },
      invalidatesTags: [{ type: "Estados Evaluaciones", id: "LIST" }],
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          queryFulfilled.then(() => {
            dispatch(
              evaluacionesApi.util.invalidateTags([
                { type: ["GruposPorEvaluaciones", "Evaluaciones"], id: "LIST" },
              ])
            );
            dispatch(
              asignaturasPorProfesorApi.util.invalidateTags([
                { type: "AsignaturasPorProfesor", id: "LIST" },
                { type: "AsignaturasPorProfesor", id: args.id },
              ])
            );
          });
        } catch (error) {
          console.log(error);
        }
      },
    }),
  }),
});

export const { useEditEstadoEvalMutation } = editEstadoEval;
